import { useEffect } from "react";
import { useTimeline } from "../../contexts/TimelineProvider/TimelineProvider";
import { useMetaVariableStore } from "./store";
import { getFramesNearCurrentTime } from "../../utils/Animation/getFramesNearCurrentTime";

export function useMetaVariableTimelineTracker() {
  const set = useMetaVariableStore((s) => s.setMetaVariable);
  const setMetaData = useMetaVariableStore((s) => s.setMetaData);
  const metaData = useMetaVariableStore((s) => s.metaVariablesData);
  const animatedMetaVariables = useMetaVariableStore((s) => s.animatedMetaVariables);
  const [tl] = useTimeline();
  const currentTime = tl?.scrubbingCurrentTime;

  useEffect(() => {
    if (animatedMetaVariables.length === 0) return;

    for (let i = 0; i < animatedMetaVariables.length; i++) {
      const animatedMetaVariable = animatedMetaVariables[i];
      const oneshots = animatedMetaVariable.oneshot ?? [];
      const interpolated = animatedMetaVariable.interpolated ?? [];

      if (oneshots?.length === 0 && interpolated?.length === 0) {
        continue;
      }

      if (interpolated?.length > 0) {
        // @ts-expect-error function expects Frame[] instead of AnimatedMetaVariableFrame[]
        const interpolatedFrame = getFramesNearCurrentTime(interpolated, currentTime);
        set(animatedMetaVariable.metaVariableKey, interpolatedFrame?.value as number);
        continue;
      }

      if (oneshots?.length > 0) {
        let lastValidFrame;
        for (let j = oneshots.length - 1; j >= 0; j--) {
          const frame = oneshots[j];
          if (frame.timestamp <= currentTime) {
            lastValidFrame = frame;
            break;
          }
        }

        if (lastValidFrame) {
          const currentMetaData = metaData[animatedMetaVariable.metaVariableKey];
          /**
           * If the frame has the isAnimating set to true,
           * we avoid setting the metaVariable itself since the value
           * will be controlled by the IMAGE_SWAP animation itself.
           */
          if (
            lastValidFrame.metadata &&
            "isAnimating" in lastValidFrame.metadata &&
            lastValidFrame.metadata.isAnimating === true
          ) {
            if (currentMetaData.isAnimating === false) {
              setMetaData(animatedMetaVariable.metaVariableKey, "isAnimating", true);
            }
          } else {
            /**
             * If `isAnimating` doesn't exist we set it as usual.
             */
            set(animatedMetaVariable.metaVariableKey, lastValidFrame.value);
            /**
             * We check in case to disable animation as it will conflict with the value
             * set in the advanced panel.
             */
            if (currentMetaData && currentMetaData.isAnimating === true) {
              setMetaData(animatedMetaVariable.metaVariableKey, "isAnimating", false);
            }
          }
        }
        continue;
      }
    }
  }, [currentTime]);
}
